export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/KR-50bfafbd4c805455881b90fd3d77aefa.png";